module.exports=function(scope){ return `// Custom text for continue button
<string name="zoom_action_continue">Custom Continue Message</string>
`};


// WEBPACK FOOTER //
// ./src/resources/code/android/21-custom-string.java.tpl